import script from "./DialogUserReject.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogUserReject.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QSeparator,QCardActions});
